// app/javascript/controllers/search_affiliates_controller.js
import { Controller } from "@hotwired/stimulus";
import debounce from "lodash/debounce";

export default class extends Controller {
  static targets = ["query", "results", "hidden"];
  static values = { url: String };

  connect() {
    console.log("SearchAffiliatesController connected");
    // debounced internal search
    this.debouncedSearch = debounce(this._search.bind(this), 300);
  }

  // called via data-action="input->search-affiliates#search"
  search(event) {
    console.log("SearchAffiliatesController search triggered");
    this.debouncedSearch(event);
  }

  async _search(event) {
    console.log("SearchAffiliatesController _search triggered");
    const query = event.target.value.trim();

    if (query.length < 3) {
      this.hideResults();
      return;
    }

    // using Ransack-style param: q[name_cont]
    const params = new URLSearchParams({ "q[name_cont]": query });

    console.log(`Fetching: ${this.urlValue}?${params.toString()}`);
    try {
      const response = await fetch(`${this.urlValue}?${params.toString()}`);
      const html = await response.text();

      if (html.trim() === "") {
        this.hideResults();
      } else {
        this.resultsTarget.innerHTML = html;
        this.showResults();
      }
    } catch (error) {
      console.error("Search error:", error);
      this.hideResults();
    }
  }

  choose(event) {
    const id   = event.currentTarget.dataset.id;
    const name = event.currentTarget.dataset.name;

    this.hiddenTarget.value = id;
    this.queryTarget.value  = name;

    this.hideResults();
  }

  showResults() {
    this.resultsTarget.classList.add("show");
  }

  hideResults() {
    this.resultsTarget.classList.remove("show");
    this.resultsTarget.innerHTML = "";
  }
}
